import './show.sass'

export default class {
    constructor() {
    }
}
